import './firebase/firebaseConfig';   // must run FIRST
import React from 'react';
import { createRoot } from 'react-dom/client'; // Updated import
import App from './App';
import './index.css';
import './firebase/firebaseConfig'; // Initialize Firebase

const container = document.getElementById('root');
const root = createRoot(container); // Use createRoot to create a root.

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
